'use client';
import React from 'react';
import Script from 'next/script';
import { OllieTheme, GlobalStyle } from '@ui/theme';
import {
  Reporter,
  ReporterProvider,
  ElevarReporterProvider,
  ElevarReporter,
} from '../reporter';
import { ToastProvider } from '../Toast/ToastProvider';
import { CampaignProvider } from '../campaign/appContext';
import { ApiProvider } from '../api';
import { ShopifyAuthProvider } from '../auth/ShopifyAuth';
import { AppShopifyCartProvider } from '../onboarding/OnboardingFlowContainer/AppShopifyCartProvider';
import { AppShopifyOfferProvider } from '../offer/appShopifyContext';
import { ErrorBoundary } from '../containers/ErrorPage/ErrorBoundary';
import { GladlyContainer } from '../gladly/appContainer';
import { EnvProvider } from './contexts/EnvContext';
import { StyledComponentsRegistry } from './StyledComponentRegistry';

const ClientProviders = ({
  envVars,
  initialSession,
  gladlyDisplayRules,
  children,
}) => {
  const reporter = new Reporter();
  const elevarReporter = new ElevarReporter();
  return (
    <EnvProvider envVars={envVars}>
      <ApiProvider initialSession={initialSession} appRouter={true}>
        <ShopifyAuthProvider initialSession={initialSession}>
          <CampaignProvider>
            <ReporterProvider reporter={reporter}>
              <ElevarReporterProvider elevarReporter={elevarReporter}>
                <StyledComponentsRegistry>
                  <OllieTheme>
                    <ToastProvider>
                      <AppShopifyCartProvider>
                        <AppShopifyOfferProvider>
                          <GlobalStyle />
                          <ErrorBoundary reporter={reporter}>
                            {children}
                          </ErrorBoundary>
                          <GladlyContainer
                            gladlySettings={{
                              displayRules: gladlyDisplayRules,
                            }}
                          />
                          <Script src="https://www.googletagmanager.com/gtag/js?id=G-H1JV5JVL6B" />
                          <Script id="google-analytics">
                            {`
                          window.dataLayer = window.dataLayer || [];
                          function gtag(){dataLayer.push(arguments);}
                          gtag('js', new Date());

                          gtag('config', 'G-H1JV5JVL6B');
                        `}
                          </Script>
                        </AppShopifyOfferProvider>
                      </AppShopifyCartProvider>
                    </ToastProvider>
                  </OllieTheme>
                </StyledComponentsRegistry>
              </ElevarReporterProvider>
            </ReporterProvider>
          </CampaignProvider>
        </ShopifyAuthProvider>
      </ApiProvider>
    </EnvProvider>
  );
};

export default ClientProviders;
